// extracted by mini-css-extract-plugin
export default {"container":"aJN2S7","external":"bJN2S7","text":"cJN2S7"};